import React from "react";
import Common from "./common";
import style from "css/lecture.module.css";
import { useMediaQuery } from "react-responsive";
import SEOMeta from "components/app/SEOMeta";
import { useDispatch } from "react-redux";
import { openPopup } from "redux/slices/drawerPopupSlice";
import NeatPopup from "components/device/neat/neatPopup";

function ClassRoom() {
  //dispatch
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });

  const HeaderInfo = {
    subTitle: "Hybrid Smart ClassRoom",
    title: "하이브리드 스마트 강의실",
    info: [
      <font>
        물리적 공간의 제약을 뛰어넘어,{"\n"} 학생들이 장소에 구애 받지 않고{" "}
        <br />
        학습에 참여할 수 있는 기회를 제공하며, <br /> 교사와 학생 간의
        상호작용을 강화하고
        <br /> 다양한 디지털 도구를 통해 학습의 질을 높입니다.
      </font>,
    ],
    img: "img/smartspace/classRoomImg1.png",
    img_m: "img/smartspace/classRoomImg1_m.png",
  };

  const BodyInfo = [
    {
      id: 1,
      txt: (
        <div className={style.bodyInfoTxtDetail}>
          {!isMobile && !isTablet ? (
            <>
              <font>
                하이브리드 스마트 강의실에서 뛰어난 화상 회의 경험을 제공하는 AI
                기반의 화상 장비로,
              </font>
              <font>
                다양한 기능을 통해 교수와 학생 간의 상호작용을 극대화합니다.
              </font>
            </>
          ) : (
            <>
              <font>
                하이브리드 스마트 강의실에서 뛰어난 화상 회의 경험을 제공하는 AI
                기반의 화상 장비로, 다양한 기능을 통해 교수와 학생 간의
                상호작용을 극대화합니다.
              </font>
            </>
          )}
        </div>
      ),
      title: "AI 화상 장비 ( AI remote learning device )",
      img: "img/smartspace/classRoomImg2.png",
      img_m: "img/smartspace/classRoomImg2_m.png",
    },
    {
      id: 2,
      txt: (
        <div className={style.bodyInfoTxtDetail}>
          {!isMobile && !isTablet ? (
            <>
              <font>
                고해상도 카메라와 고성능 마이크를 탑재하여, 선명한 영상과 명확한
                음성을 제공하며,
              </font>
              <font>
                교수나 발표자를 자동으로 추적하여 최적의 화각을 제공합니다.
              </font>
            </>
          ) : (
            <>
              <font>
                고해상도 카메라와 고성능 마이크를 탑재하여, 선명한 영상과 명확한
                음성을 제공하며, 교수나 발표자를 자동으로 추적하여 최적의 화각을
                제공합니다.
              </font>
            </>
          )}
        </div>
      ),
      title: "발표자 추적 시스템 ( Speaker Tracking System )",
      img: "img/smartspace/classRoomImg3.png",
      img_m: "img/smartspace/classRoomImg3_m.png",
    },
    {
      id: 3,
      txt: (
        <div className={style.bodyInfoTxtDetail}>
          {!isMobile && !isTablet ? (
            <>
              <font>
                강의실 내 모든 디지털 장비(프로젝터·스마트
                보드·카메라·마이크·조명 등)를
              </font>
              <font>
                하나의 인터페이스에서 통합적으로 제어할 수 있는 소프트웨어
                프로그램 입니다.
              </font>
            </>
          ) : (
            <>
              <font>
                강의실 내 모든 디지털 장비(프로젝터·스마트
                보드·카메라·마이크·조명 등)를 하나의 인터페이스에서 통합적으로
                제어할 수 있는 소프트웨어 프로그램 입니다.
              </font>
            </>
          )}
        </div>
      ),
      title: "스마트 강의 컨트롤 시스템",
      img: "img/smartspace/classRoomImg4.png",
      img_m: "img/smartspace/classRoomImg4_m.png",
    },
  ];

  const BodyFooter = [
    {
      id: 1,
      txt: "AI 장비의 자동 프레이밍을 통해 강의 중 교수자나 발표자를 자동으로 추적하고 최적의 화각으로 프레임을 맞추어 발표자가 이동하면서도 원활한 강의를 진행할 수 있도록 도와줍니다.",
      title: (
        <p>
          최첨단 <font>AI 기반 자동화</font> 기능
        </p>
      ),
    },
    {
      id: 2,
      txt: "Zoom, Microsoft temas등 주요 화상회의 플랫폼과 완벽하게 호환되어 원격지 학생들도 실시간으로 강의에 참여할 수 있으며, 강의를 실시간으로 스트리밍하고 녹화하여 이후에 학생들이 다시 볼 수 있도록 합니다.",
      title: (
        <p>
          <font>원활한 원격 학습</font> 지원
        </p>
      ),
    },
    {
      id: 3,
      txt: "Smart Class Controller 솔루션과 같은 통합 관리 시스템을 통해 neat장비를 비롯한 모든 강의실 장비를 하나의 플랫폼에서 관리할 수 있으며, 스마트 워크 플랫폼 all Place를 통해 강의 예약/다가오는 일정/현황 확인 등 강의 스케줄 관리에 최적화된 솔루션을 사용하실 수 있습니다.",
      title: (
        <p>
          통합 컨트롤 및 관리<font> 솔루션</font>
        </p>
      ),
    },
  ];
  const Compose = [
    {
      id: 1,
      img: "img/smartspace/composeImg2.png",
      title: "스마트 강의 컨트롤 시스템",
      txt: "스마트 강의 컨트롤 시스템은 강의실 내 장비와 디지털 콘텐츠를 통합 관리하여, 교수와 학생 모두에게 최적화된 학습 환경을 제공합니다. 실시간 강의, 화면 공유, 출석 관리 등을 손쉽게 운영할 수 있으며, 하이브리드 수업에 효과적으로 대응할 수 있도록 설계되었습니다.",
      onClick: () => showDrawer("deviceone"),
    },
    {
      id: 2,
      img: "img/device/neat/swiper_bar_2.png",
      title: "화상회의 장비 neat. bar generation2",
      txt: "Neat Bar는 화상 강의를 위한 고성능 장비로, AI 기반의 카메라 기능으로 수업 중 발표자에 집중할 수 있도록 하여, 원격 및 하이브리드 학습환경에서 최적의 강의 경험을 지원합니다.",
      onClick: () => showDrawer("bar2"),
    },
    // {
    //   id: 3,
    //   img: "img/device/neat/swiper_bar_pro.png",
    //   title: "화상회의 장비 neat. bar",
    //   txt: "Neat Bar Pro는 강의실 전면에 설치하여 넓은 범위의 화자를 선명하게 포착하는 고성능 화상 강의 장비입니다. 대형 강의실에서도 몰입감 있는 수업 환경을 지원합니다.",
    //   onClick: () => showDrawer("bar"),
    // },
    {
      id: 3,
      img: "img/device/neat/swiper_board_pro.png",
      title: "화상회의 장비 neat. board Pro",
      txt: "Neat Board Pro는 디지털 화이트보드와 화상회의 기능을 결합한 올인원 장비로, 강의실에서 실시간 협업과 몰입감 있는 강의를 지원합니다.",
      onClick: () => showDrawer("boardpro"),
    },
  ];
  const showDrawer = (menu) => {
    dispatch(
      openPopup({
        type: menu,
      })
    );
    document.querySelector("#page_header").style.height = "0";
  };
  const BodyHeader = (
    <div className={style.bodyTitle}>
      <p>수업 및 강의</p>
      <p>종합 학습 환경 제공을 위한{"\n"} 하이브리드 스마트 강의실</p>
      {!isMobile && !isTablet ? (
        <p>
          AI화상장비를 통해 대면과 원격 학습자 모두 실시간 상호작용 가능 <br />
          다양한 학습 도구와 화상회의 플랫폼을 통해 학습자와의 소통을 극대화
        </p>
      ) : (
        <p>
          AI화상장비를 통해 대면과 원격 학습자 모두 실시간{"\n"} 상호작용 가능
          다양한 학습 도구와 화상회의 플랫폼을{"\n"} 통해 학습자와의 소통을
          극대화
        </p>
      )}
    </div>
  );
  const BodyFooterTitle = (
    <div className={style.bodyFooterTitle}>
      <p>Riv Technology의{"\n"} 하이브리드 강의실 구축은 </p>
      <p>
        <font>강의실 환경에 맞춰 설계</font>되어,
      </p>
      <p>
        교수와 학생에게{"\n"} <font>혁신적인 학습 환경</font>을 제공합니다.
      </p>
    </div>
  );
  const ComposeHeader = (
    <div className={style.commonComposeTitle}>
      하이브리드 강의실 <font>구성 환경</font>
    </div>
  );

  return (
    <>
      <SEOMeta
        title="하이브리드 스마트 강의실, 리브테크놀로지"
        description="리브테크놀로지 riv Technolohy - 하이브리드 스마트 강의실"
        keywords="리브테크놀로지, 리브테크, 리브, riv, riv Technology, neat, 스마트 회의실, 화상회의, 하이브리드 스마트 강의실"
      />
      <NeatPopup />
      <div>
        <Common
          headerInfo={HeaderInfo}
          bodyHeader={BodyHeader}
          bodyInfo={BodyInfo}
          bodyFooter={BodyFooter}
          compose={Compose}
          bodyFooterTitle={BodyFooterTitle}
          composeHeader={ComposeHeader}
        />
      </div>
    </>
  );
}

export default ClassRoom;
